import React, { useEffect } from 'react';
import useAuth from '../hooks/useAuth';
import { Navigate } from 'react-router-dom';
import Layout from './Layout/Layout';

const ProtectedRoute = ({ element: Component, layout: selectedLayout = Layout, ...rest }) => {
    const { authToken } = useAuth();

    return authToken ? (
        selectedLayout ? 
                <Layout>   
                    <Component {...rest} />
                </Layout> 
        : 
            <Component {...rest} />
    ) : (
        <Navigate to="/" />
    );
};

export default ProtectedRoute;
